import { toRFC3339UTC } from './geohashUtil';

export const SEED_REPORTS = [
  {
    id: 1,
    thread_id: 3,
    reporter_user_id: 1009,
    report_type: 1,
    detail: 'Spam content',
    status: 0,
    created_at: toRFC3339UTC(new Date(Date.now() - 86400000)),
  },
  {
    id: 2,
    thread_id: 8,
    reporter_user_id: 1002,
    report_type: 2,
    detail: 'Off-topic',
    status: 0,
    created_at: toRFC3339UTC(new Date(Date.now() - 43200000)),
  },
  {
    id: 3,
    thread_id: 1,
    reporter_user_id: 1005,
    report_type: 1,
    detail: null,
    status: 1,
    created_at: toRFC3339UTC(new Date(Date.now() - 172800000)),
  },
];
